import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { IconPhone } from '../components/Icons';

const IconPause = ({ size = 16 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>);
const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));

function Bar({ c, l, p, v }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 2px' }}>
      <span style={{ width: 12, height: 12, borderRadius: '50%', background: c, flex: '0 0 auto' }} />
      <span style={{ flex: 1, fontSize: 13 }}>{l}</span>
      <div style={{ flex: '0 0 70px', height: 6, background: 'var(--line)', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{ width: `${p}%`, height: '100%', background: c }} />
      </div>
      <span style={{ flex: '0 0 54px', textAlign: 'right', fontSize: 13, fontWeight: 700 }}>{nf(v)} · {p}%</span>
    </div>
  );
}

export default function A456Page() {
  const [ag, setAg] = useState(null);
  const [stats, setStats] = useState(null);
  const [vstats, setVstats] = useState(null);
  const [lead, setLead] = useState(0);
  const load = useCallback(() => {
    axios.get(`${API}/agent/status`).then((r) => setAg(r.data)).catch(() => {});
    axios.get(`${API}/stats`).then((r) => setStats(r.data)).catch(() => {});
    axios.get(`${API}/verify-stats`).then((r) => setVstats(r.data)).catch(() => {});
    axios.get(`${API}/numeri?lead=true&limit=1`).then((r) => setLead(r.data?.total ?? 0)).catch(() => {});
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [load]);

  if (!stats) return <div className="m-empty">Caricamento…</div>;

  const attivo = !!ag?.attivo;
  const standby = ag?.standby || ag?.status === 'standby';
  const verif = stats.verificati || 0, tim = stats.tim || 0, nonTim = stats.non_tim || 0;
  const err = Math.max(0, verif - tim - nonTim);
  const pct = (x) => (verif ? Math.round((100 * x) / verif) : 0);

  return (
    <>
      <div className={`m-verdict ${attivo && !standby ? '' : 'warn'}`}>
        <span className="vi">{attivo ? <IconPhone size={16} /> : <IconPause size={16} />}</span>
        <div>
          <div className="vt">{standby ? 'AI in standby (disservizio)' : attivo ? 'AI in chiamata' : 'AI 456 fermo'}</div>
          <div className="vs">{attivo ? `${nf(ag?.velocita_min)}/min · ${nf(ag?.pending)} in coda` : `${nf(ag?.pending)} in coda`}</div>
        </div>
      </div>

      <div className="m-secrow"><h2>Numeri</h2></div>
      <div className="m-chips">
        <div className="m-chip"><div className="cn">{nf(verif)}</div><div className="cl">Verificati</div></div>
        <div className="m-chip k-tim"><div className="cn">{nf(tim)}</div><div className="cl">TIM {pct(tim)}%</div></div>
        <div className="m-chip k-non"><div className="cn">{nf(nonTim)}</div><div className="cl">NON TIM {pct(nonTim)}%</div></div>
        <div className="m-chip k-lead"><div className="cn">{nf(lead)}</div><div className="cl">Lead fibra</div></div>
      </div>

      <div className="m-secrow"><h2>Ripartizione esiti</h2></div>
      {verif === 0 ? (
        <div className="m-empty">Nessun numero ancora verificato.</div>
      ) : (
        <>
          <Bar c="#16a34a" l="NON TIM" p={pct(nonTim)} v={nonTim} />
          <Bar c="#e11d48" l="TIM" p={pct(tim)} v={tim} />
          <Bar c="#f59e0b" l="Errori" p={pct(err)} v={err} />
        </>
      )}

      <div className="m-secrow"><h2>Attività</h2></div>
      <div className="m-chips">
        <div className="m-chip"><div className="cn">{nf(vstats?.verifiche_24h)}</div><div className="cl">Verifiche 24h</div></div>
        <div className="m-chip"><div className="cn">{ag?.velocita_min ? nf(ag.velocita_min) : '—'}</div><div className="cl">/min</div></div>
        <div className="m-chip k-non"><div className="cn">{nf(ag?.pending)}</div><div className="cl">Da fare</div></div>
      </div>
    </>
  );
}
